import React from 'react';
import PropTypes from 'prop-types';

import CategoryItem from '../CategoryItem';

const CategoriesSection = ({ categories }) => {
  return (
    <section
      className="section"
      style={{ backgroundColor: 'transparent', paddingTop: '45px', paddingBottom: '45px' }}
    >
      <h2 className="section__header__title section__header__title--mb-45">Tüm Kategoriler</h2>
      <div className="container">
        <div className="row row--mb30 features justify-content-center">
          {categories.map((category) => (
            <CategoryItem key={category.id} category={category} />
          ))}
        </div>
      </div>
    </section>
  );
};

CategoriesSection.propTypes = {
  categories: PropTypes.array,
};

export default CategoriesSection;
